const style = (theme): any => ({
    formInput: {},
    partnerInfo: {},
    partnerInfoLabel: {
        color: theme.palette.secondary.light,
    },
    card: {
        '& .MuiCardContent-root': {
            paddingBottom: 0,
        },
    },
    driversCtn: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    driverInfo: {
        width: '350px',
        margin: theme.spacing(1),
    },
    vehiclesCtn: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    vehicleInfo: {
        width: '300px',
        margin: theme.spacing(1),
    },
    bold: {
        fontWeight: 'bold',
    },
    rightActions: {
        justifyContent: 'flex-end',
    },
    itemsHideTitle: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
    },
});
export default style;
